<template>
     <div id="payment" class="popup-container d-flex align-items-center justify-content-center text-box" :class="{'d-none': !show}" v-if="infos">

        <div class="popup-box bg-white px-3 px-sm-4 px-lg-5 pt-5 pb-4 position-relative popup-payment">
            <a href="#"
                @click.prevent="hide"
                class="close-popup position-absolute">
                <img src="/images/icons/icon-close-popup.svg" title="Close">
            </a>

            <form class="form steps-content position-relative">
                <div v-if="step==1" :class="{active: step==1}">

                    <Form
                        ref="form"
                        novalidate
                        @submit="onConfirm"
                        @invalid-submit="onInvalid"
                        class="form"
                        v-slot="{ errors, values, meta }"
                    >
                        <p class="tincx-h4 my-0" v-if="infos.type=='single'">{{ infos.name }}</p>

                        <div v-if="infos.entry" class="alert alert-info mt-3">
                            Die Anfrage betrifft die Anzeige:
                            <b>{{ infos.entry.title }}</b>
                        </div>

                        <p v-html="infos.description"></p>


                        <p>Wir werden dir ein genaues Angebot unterbreiten.<br>Im Kommentarfeld können Sie uns bereits Wünsche / Infos mitteilen:</p>

                        <Field
                            as="textarea"
                            name="comment"
                            placeholder="Kommentar (optional)"
                            rules=""
                            rows="3"
                            v-model="comment"
                            class="mt-2"
                            :class="{ 'is-invalid': errors.content }"
                        />
                        <ErrorMessage as="div" name="content" class="invalid-feedback" />

                        <div class="mt-3">
                            <button class="btn btn-primary btn-bs">Jetzt anfragen!</button>
                        </div>
                    </Form>
                </div>

                <div v-if="step==2 && successInfo" :class="{active: step==2}" class="pb-3">
                    <p class="my-0 tincx-h4">{{ successInfo.title }}</p>
                    <p v-html="successInfo.description"></p>
                    <a v-for="btn in successInfo.buttons" :href="btn.url" :class="btn.class" class="col-12 col-xs-auto btn btn-bs me-1">{{ btn.name }}</a>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import emitter from '../plugins/mitt';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import { Form, Field, ErrorMessage } from 'vee-validate';

export default {
    name: 'Upselling',
    components: {
        Form,
        Field,
        ErrorMessage
    },
    inject: ['$t', '$f'],
    mounted: async function () {
        this.loadData()
        emitter.on('upselling-payment-infos', (val) => {
            this.infos = val
        })
        emitter.on('popup', (val) => {
            this.show = val=='upselling-payment' ? true : false
            this.step = 1
            this.comment = null
        })
        //this.show = true
    },
    computed: {

    },
    watch: {
        step: function() {
            document.getElementsByClassName('popup-payment')[0].scrollTop = 0
        },
    },
    methods: {
        loadData: function() {

        },
        onInvalid: function({values, errors, results}) {
            let html = '<ul>'+Object.values(errors).map(e => '<li>'+e+'</li>').join('')+'</ul>'
            Swal.fire({
                title: this.$t('generic.error'),
                html: html,
                icon: 'error'
            });
        },
        hide: function() {
            if(this.step==2) {
                this.$emit('reloadData')
            }
            emitter.emit('popup', false)
        },
        nextStep: function() {
            if(this.step==2) {
                return
            }
            this.step++
        },
        prevStep: function() {
            if(this.step==2) {
                return
            }
            this.step--
        },
        onConfirm: function() {
            Swal.fire({
                text: this.$t('generic.loading'),
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading()
                },
            });


            let values = {
                infos: this.infos,
                url: window.location.href,
                section: this.infos.section,
                entry: this.infos.entry,
                comment: this.comment
            }

            axios
                .post('/api/upselling/request', { ...values })
                .then((response) => {
                    console.log(response)
                    if (response.data.error) {
                        Swal.fire(this.$t('generic.error'), response.data.error, 'error')
                        return
                    }

                    if(response.data.redirect) {
                        window.location.href = response.data.redirect
                        return
                    }

                    Swal.close()
                    this.step = 2
                    this.successInfo = response.data.success
                })
                .catch((error) => {
                    console.log(error)
                    Swal.fire(this.$t('generic.error'), this.$t('generic.error_try_again_later'), 'error')
                })
        },


        disableAbo: function(data) {
            var terminateDate = data.terminateDate
            var activate = data.aboAction == 'activate'
            Swal.fire({
                title: activate ? "ABO aktivieren" : "ABO deaktivieren",
                html: activate ? "Möchten Sie die Automatische Erneuerung Ihres ABOs am "+terminateDate+" wieder aktiviern?" : "Ihr ABO läuft am "+terminateDate+" aus.<br><br>Möchten Sie Ihr ABO wirklich kündigen und zur nächsten Fälligkeit nicht mehr automatisch erneuren?<br><br>Bis zum "+terminateDate+" können Sie das ABO weiterhin nutzen.",
                showDenyButton: true,
                showConfirmButton: false,
                showCancelButton: true,
                denyButtonText: activate ? "Ja, ABO-Erneuerung aktivieren" : "Ja, Verlängerung deaktivieren",
                denyButtonColor: activate ? 'green' : 'red',
                cancelButtonText: `Abbrechen`
                }).then((result) => {
                    if (result.isDenied) {
                        Swal.fire({
                            text: this.$t('generic.loading'),
                            allowOutsideClick: false,
                            didOpen: () => {
                                Swal.showLoading()
                            },
                        });
                        axios
                            .post('/api/buy/terminate', { ...data })
                            .then((response) => {
                                console.log(response)
                                if (response.data.error) {
                                    Swal.fire(this.$t('generic.error'), response.data.error, 'error')
                                    return
                                }

                                if(response.data.redirect) {
                                    window.location.href = response.data.redirect
                                    return
                                }

                                Swal.fire({
                                    title: response.data.title,
                                    text: response.data.message,
                                    icon: 'success',
                                    didClose: () => {
                                        window.location.reload()
                                    }
                                })
                            })
                            .catch((error) => {
                                console.log(error)
                                Swal.fire(this.$t('generic.error'), this.$t('generic.error_try_again_later'), 'error')
                            })
                    }
                });
        }

    },
    data() {
        return {
            show: false,
            comment: null,
            infos: null,
            loading: false,
            successInfo: null,
            step: 1,
        }
    },
}
</script>
